import { useCallback, useState } from 'react';
import useChoferes from '../services/ChoferService';

export const useChofer = () => {
  const ChoferService = useChoferes();

  const [drivers, setDrivers] = useState<any>([]);
  const [filters, setFilters] = useState<any>({
    page: 1,
    perPage: 10,
    sort_by: null,
    sort_order: null,
    isDeleted: 'No'
  });
  const [loading, setLoading] = useState(false);

  const onLoadDrivers = useCallback(
    async (searchText: string = '', resetPage?: boolean) => {
      const search = searchText.trim().length > 0 ? searchText.trim() : null;

          if (search && resetPage) {
      setFilters(prev => ({
        ...prev,
        page: 1
      }));
      return; 
    }

      const params = new URLSearchParams();

      if (filters?.page) params.append('page', String(filters.page));
      if (filters?.perPage) params.append('perPage', String(filters.perPage));

      if (filters?.code) {
        params.append('code', filters.code);
      }

      if (filters?.isDeleted){
        params.append('isDeleted', filters.isDeleted === 'No' ? 'false' : 'true');
      }  

      if (search) {
        params.append('search', search);
      }

      if (filters?.sort_by && filters?.sort_order) {
        params.append('sort_by', filters.sort_by);
        params.append('sort_order', filters.sort_order);
      }

      // Generar la cadena de consulta
      const parsedParams = params.toString() ? `?${params.toString()}` : '';
      try {
        setLoading(true);
        const data = await ChoferService.getChoferesWithDeleted(
          parsedParams ?? null
        );
        setDrivers(data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    },
    [ChoferService, filters]
  );

  const onChangeFilters = (flters: any) => setFilters(flters);

  return {
    drivers,
    filters,
    loading,
    onChangeFilters,
    onLoadDrivers
  };
};
